import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './canva.css';

const Canva = ({setHideCursor, setIsFirstLoad}) => {
    const { CanvaID } = useParams(); 
    
    const [canvaLink, setCanvaLink] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const GOOGLE_SHEET_CSV_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vRWU_IzEhRpcLF7YYREUQ74StmpE3Frt2VlFwtF_24iD8gzBeKgvF8dSdJEiTRK8ZquBlQb6kwLjV-I/pub?gid=0&single=true&output=csv";
    
    useEffect(() => {
        setHideCursor(true);
        const fetchCanvaLink = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(GOOGLE_SHEET_CSV_URL);
                if (!response.ok) throw new Error("Failed to fetch sheet data");
                
                const csvText = await response.text();
                const rows = csvText.split('\n');
                let foundLink = null;

                for (let i = 1; i < rows.length; i++) { 
                    const row = rows[i];
                    const firstCommaIdx = row.indexOf(',');
                    if (firstCommaIdx === -1) continue;

                    const projectName = row.substring(0, firstCommaIdx).trim();
                    const embedLink = row.substring(firstCommaIdx + 1).trim();

                    if (projectName.toLowerCase() === CanvaID.toLowerCase()) {
                        // Format the link to ensure it embeds correctly
                        let safeLink = embedLink;
                        
                        // Strip trailing slashes just in case the client added one
                        if (safeLink.endsWith('/')) {
                            safeLink = safeLink.slice(0, -1);
                        }

                        // Check if it already has 'embed'
                        if (!safeLink.includes('embed')) {
                            // If it has a '?' already, use '&', otherwise use '?'
                            safeLink += safeLink.includes('?') ? '&embed' : '?embed';
                        }
                        
                        foundLink = safeLink;
                        break;
                    }
                }

                if (foundLink) {
                    setCanvaLink(foundLink);
                } else {
                    setError("Project not found. Please check the URL.");
                }
            } catch (err) {
                console.error(err);
                setError("Could not load the project database.");
            } finally {
                setIsLoading(false);
            }
        };

        if (CanvaID) {
            fetchCanvaLink();
        } else {
            setError("No project ID provided.");
            setIsLoading(false);
        }
    }, [CanvaID]);

    useEffect(() => {
        return () => {
            setIsFirstLoad(true);
        }
    }, [])

    return (
        <HelmetProvider>
            <Helmet>
                <title>Double Or Nothing Creative Pitch | {CanvaID}</title>
                <meta name="description" content={`Double Or Nothing Creative Pitch - ${CanvaID}`} />
                <meta property="og:description" content={`Double Or Nothing Creative Pitch - ${CanvaID}`} />
            </Helmet>

            <div className="canva-wrapper" onMouseEnter={() => setHideCursor(true)} onMouseLeave={() => setHideCursor(false)}>
                <div className="canva-content">
                    <div className="canva-board">
                        {isLoading && <p>Loading your design...</p>}
                        
                        {error && !isLoading && <p className="error-text">{error}</p>}
                        
                        {!isLoading && !error && canvaLink && (
                            <iframe
                                title={`Canva Design for ${CanvaID}`}
                                loading="lazy"
                                src={canvaLink}
                                allowFullScreen
                            ></iframe>
                        )}
                    </div>
                </div>
            </div>
        </HelmetProvider>
    );
}

export default Canva;